import { Power2 } from 'gsap';

import DraggablePreset from './DraggablePreset';
import TextBlock from '../../graphics/TextBlock';
import { getCenterX, getCenterY } from '../../utils/CoordinateCalculator';

const MAX_DURATION = 3;

export default class CutWords extends DraggablePreset {
  constructor(app) {
    super(app);

    this.textBlock = new TextBlock(app);
    this.container.addChild(this.textBlock);
  }

  update(model) {
    super.update(model);

    const animationDuration = Math.min(this.duration, MAX_DURATION);
    const outDuration = animationDuration / 6;
    const inDuration = animationDuration - outDuration;

    this.textBlock.updateTextAndStyle(model.text, model);
    this.setDraggableRoot(
      this.textBlock.blockHeight,
      this.textBlock.blockWidth
    );
    this.textBlock.x = getCenterX(
      { width: this.textBlock.blockWidth },
      this.root
    );
    this.textBlock.y = getCenterY(
      { height: this.textBlock.blockHeight },
      this.root
    );

    this.textBlock.forEachWord((text, { index }) => {
      text.alpha = 0;
      this.animate(text.lineControls).to(
        {
          alpha: 1,
          duration: 0.01, // GSAP was acting glitchy when I tried this with duration: 0
        },
        (inDuration * index) / this.textBlock.numWords
      );
    });

    this.textBlock.alpha = 1;
    this.animate(this.textBlock).to(
      {
        alpha: 0,
        duration: outDuration,
        ease: Power2.easeIn,
      },
      this.duration - outDuration
    );
  }
}
